import { SxProps } from "@mui/material";
import theme from "../../../theme";

export const suffixSx: SxProps = {
  color: theme.palette.neutral[400],
  fontSize: '0.75rem'
}
